import types from './types'

export { default as actions } from './actions'

const INITIAL_STATE = { titles: [], titlesRequested: false, isLoadingTitles: false }

const reducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case types.FETCH_CAREER_TITLES_START:
      return { ...state, isLoadingTitles: true, titlesRequested: true }
    case types.FETCH_CAREER_TITLES_SUCCESS:
      return {
        ...state,
        titles: action.payload,
        isLoadingTitles: false,
      }
    case types.FETCH_CAREER_TITLES_FAILURE: {
      return { ...state, isLoadingTitles: false }
    }
    default:
      return state
  }
}

export const selectCareerTitles = (store) => store.careerTitles?.titles || []

export default reducer
